const ORDER_STATUS_META = {
    pending: { label: '待付款', color: 'orange', hint: '會員已下單，等待付款' },
    paid: { label: '已付款', color: 'green', hint: '訂單已完成付款' },
    completed: { label: '已完成', color: 'blue', hint: '訂單已結案完成' },
    cancelled: { label: '已取消', color: 'gray', hint: '訂單已取消' },
    cancellation_pending: {
        label: '取消審核中',
        color: 'red',
        hint: '取消申請審核中'
    },
    refunding: { label: '退款中', color: 'orange', hint: '退款處理中' },
    partially_refunded: { label: '部分退款', color: 'orange', hint: '訂單部分品項已退款' },
    refunded: { label: '已退款', color: 'gray', hint: '退款已完成' },
    refund_failed: { label: '退款失敗', color: 'red', hint: '退款處理失敗' }
};

/** 依訂單時間戳估算可顯示的狀態歷程筆數 */
export function countOrderStatusMilestones(record) {
    if (!record) return 0;
    let count = 0;
    if (record.placed_at) count += 1;
    if (record.paid_at) count += 1;
    if (record.completed_at) count += 1;
    if (record.cancelled_at) count += 1;
    return count;
}

/** 列表／詳情是否顯示「紀錄」按鈕：僅在有多於一個狀態節點時 */
export function canShowOrderStatusLog(record) {
    return countOrderStatusMilestones(record) > 1;
}

export function getOrderStatusMeta(status) {
    return (
        ORDER_STATUS_META[status] || {
            label: status || '未知狀態',
            color: 'gray',
            hint: ''
        }
    );
}

/** 將 API /history 回傳格式轉成 UI 用的時間軸項目 */
export function formatOrderStatusHistoryLogs(logs = []) {
    return (Array.isArray(logs) ? logs : [])
        .filter((log) => log?.created_at)
        .map((log, index) => {
            const meta = getOrderStatusMeta(log.status);
            return {
                key: `${log.status || 'unknown'}-${log.created_at}-${index}`,
                status: log.status,
                title: meta.label,
                hint: meta.hint,
                color: meta.color,
                created_at: log.created_at
            };
        })
        .sort((a, b) => new Date(a.created_at) - new Date(b.created_at));
}
